/* eslint-disable
    func-names,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const deps = ['Model', 'Relation'];
const factory = function (Model, Relation) {
  class LedgerCategory extends Model {
    static initClass() {
      this.prototype.id = null;
      this.prototype.name = null;

      this.prototype.$resource = 'ledgeraccountcategory';

      this.prototype.$order = Relation('LedgerCategoryOrder', 'id');
    }

    // overrides to prevent usage
    $put() {}
    $fetch() {}
    $post() {}
    $delete() {}
  }
  LedgerCategory.initClass();

  return LedgerCategory;
};

factory.$inject = deps;

const moduleDeps = [require('data/util').name];

module.exports = angular
  .module('bench.data.model.ledgerCategory', moduleDeps)
  .factory('LedgerCategory', factory);
